import PlatformIcon from "../Generic/PlatformIcon";
import { formatNumber } from "@/utils/format";

export default function CreatorSocialCard({
  url,
  platform,
  handle,
  followers,
  posts,
}: {
  url: string;
  platform: string;
  handle: string;
  followers: number;
  posts: number;
}) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-col gap-1 px-3 py-2 rounded-lg bg-secondary text-primary/60 hover:text-primary transition-colors text-sm"
    >
      <div className="flex items-center gap-1.5">
        <PlatformIcon platform={platform} />
        <span>@{handle}</span>
      </div>
      <div className="flex items-center gap-2 text-xs text-primary/60">
        <span>{formatNumber(followers)} followers</span>
        <span>•</span>
        <span>{formatNumber(posts)} videos</span>
      </div>
    </a>
  );
}
